import React from 'react'
import { useState } from 'react'
import Item from './item';
import '../../../css/public/faq.css'
import DocumentMeta from 'react-document-meta';

const Index = () => {
  const meta = {
    /*title: 'New Arrivals | Latest & trendy Products on KAAY',
    description: "Discover the latest products from various Brands, local vendors & artists in our New Arrivals section. From clothing, accessories, handmade crafts to unique gifts, there's something for everyone in our constantly updated selection. Our social commerce platform makes it easy for sellers to showcase their products & reach a wider audience.",
    */
    canonical: window.location.href
    /*canonical: 'http://example.com/path/to/page',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'react,meta,document,html,tags'
        }
    }*/
  }
    const [faqs,setFaqs] = useState([
        {
          question:"What is KAAY?",
          answer:["KAAY is Pakistan’s first fashion social commerce [s-commerce] platform that will act as a two-sided marketplace. A unique blend of Instagram and eBay with every seller getting back end features as Shopify without any SignUp cost. Other than the fashion industry KAAY will be boarding local artists to publish and sell their artwork and craft products on this platform."]
        },
        {
          question:"How to use KAAY?",
          answer:["Users will have profile pages that function as mini digital storefronts, where they post pictures and descriptions of what they’re selling, along with a price. You can follow your favorite sellers and view their wares in a feed. There’s also an “Explore” page featuring curated picks and trending items in different categories, such as eastern and western wear. Posts will contain hashtags, just like on Instagram, to make searching for items easier"]
        },
        {
          question:"KAAY’s Vision",
          answer: [
            "KAAY’s vision is to open a platform where all the on board business can showcase and sell their product in international markets. With this vision the business can get international exposure without spending any money.",
            "Being a borderless online platform, international exposure will increase exports of our country and KAAY intend to contribute in Pakistan’s economy."
          ]
        },
        {
          question:"What is the delivery system?",
          answer:[
            "KAAY is providing a hassle free delivery system to its sellers. After receiving the order seller will create and print shipping labels automatically from KAAY’s Dashboard. Within 12 - 24 hours the order will be picked up from your doorstep and will be delivered to customers within 3 to 5 working days.",
            "The seller will be charged Rs 49 per order up to the weight of 3 Kg."
          ]
        },
        {
          question:"Can we boost our product at KAAY?",
          answer:[
            "Sellers can boost their one product at a time Without any upfront cost. Additional 8% commission will be charged after boosted product is sold",
            "This feature will encourage sellers to boost their top selling and high inventory products to improve their cash flows."
          ]
        },
        {
          question:"What is KAAY’s commission and payments?",
          answer:[
            "12% Commission will be charged on sale exclusive of delivery cost and payments will be released within 7 working days."
          ]
        }
    ]);
  return (
    <div className='faq_wrapper'>
    <DocumentMeta {...meta} />
      <div className='faq_container'>
        <h1>{"FAQs (How it works)"}</h1>
        <div className='faq_items_container'>
            {
                faqs.map((item,index)=>{
                    return(
                        <Item Value = {item} key={index} />
                    )
                })
            }
        </div>
      </div>
    </div>
  )
}

export default Index
